import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  NavLink,
} from "reactstrap";
import { useFormik } from "formik";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UniversityService from "../../../services/KangarooServices/UniversityService";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const InstituteIntellForm = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [intellData, setIntellData] = useState();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const isUpdate = window.location.pathname.includes("/update/");

  const fetchInstituteIntell = async (id) => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await UniversityService.getIntellbyId(id);
      setIntellData(response);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstituteIntell(id);
  }, [id]);

  const formik = useFormik({
    initialValues: {
      sections: intellData
        ? intellData.map((item) => ({
            id: item.id,
            headingName: item.headingName || "",
            orderIndex: item.orderIndex || 1,
            description: item.description || "",
            url: item?.url,
          }))
        : [
            {
              headingName: "",
              orderIndex: 1,
              description: "",
              url: "",
            },
          ],
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        if (isUpdate) {
          await UniversityService.updateIntell(id, values.sections);
        } else {
          await UniversityService.createIntell(id, values.sections);
        }
        toast.success("Institute saved successfully");
        navigate("/institute");
      } catch {
        toast.error("Something went wrong");
      }
    },
  });

  const addSection = () => {
    const updated = [
      ...formik.values.sections,
      {
        headingName: "",
        orderIndex: null,
        description: "",
        url: "",
      },
    ];
    formik.setFieldValue("sections", updated);
    setActiveTab(updated.length - 1);
  };

  const removeSection = (index) => {
    const updated = [...formik.values.sections];
    updated.splice(index, 1);
    formik.setFieldValue("sections", updated);
    setActiveTab((prev) => (prev > 0 ? prev - 1 : 0));
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Institute Intelligence"
          pageTitle="Affiliated Institute"
          breadcrumbItems={[{ title: "Back to List", link: "/institute" }]}
        />

        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {isUpdate ? "Update" : "Create"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => navigate("/institute")}
            >
              Cancel
            </button>
          </div>

          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Sections</h5>
                <Button color="primary" size="sm" onClick={addSection}>
                  + Add Section
                </Button>
              </div>

              {/* Tabs */}
              <Nav tabs className="mb-3">
                {formik.values.sections.map((_, index) => (
                  <NavItem key={index}>
                    <NavLink
                      active={activeTab === index}
                      onClick={() => setActiveTab(index)}
                      style={{ cursor: "pointer" }}
                    >
                      Section {index + 1}
                      {formik.values.sections.length > 1 && (
                        <i
                          className="mdi mdi-close ms-2"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            removeSection(index);
                          }}
                        />
                      )}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              {/* Tab Content */}
              <TabContent activeTab={activeTab}>
                {formik.values.sections.map((section, index) => (
                  <TabPane tabId={index} key={index}>
                    <Row>
                      <Col md={12}>
                        <div className="mb-2">
                          <Label>
                            Heading Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            value={section.headingName}
                            onChange={(e) =>
                              formik.setFieldValue(
                                `sections.${index}.headingName`,
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </Col>

                      <Col md={4}>
                        <div className="mb-2">
                          <Label>
                            Order Index <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="number"
                            value={section.orderIndex}
                            onChange={(e) =>
                              formik.setFieldValue(
                                `sections.${index}.orderIndex`,
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </Col>
                      <Col md={8}>
                        <div className="mb-2">
                          <Label>Url</Label>
                          <Input
                            type="text"
                            value={section.url}
                            onChange={(e) =>
                              formik.setFieldValue(
                                `sections.${index}.url`,
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="mb-2">
                          <Label>
                            Description <span className="text-danger">*</span>
                          </Label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={section.description}
                            onChange={(event, editor) =>
                              formik.setFieldValue(
                                `sections.${index}.description`,
                                editor.getData(),
                              )
                            }
                          />
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                ))}
              </TabContent>
            </CardBody>
          </Card>
        </form>
      </Container>
    </div>
  );
};

export default InstituteIntellForm;
